<div class="header bg-primary">
    <div class="header-content">
        <div class="header-icon">
            <ng-content select="[saiDialogHeaderIcon]"></ng-content>
            @if (icon) {
                <mat-icon [svgIcon]="icon"></mat-icon>
            } @else if (iconLigature) {
                <mat-icon>{{ iconLigature }}</mat-icon>
            }
        </div>
        <div class="header-text">
            <h1 class="header-title">
                <ng-content select="[saiDialogHeaderTitle]"></ng-content>
                @if (title) {
                    {{ title }}
                }
            </h1>
            @if (subtitle) {
                <div class="header-subtitle">{{ subtitle }}</div>
            }
            <ng-content select="[saiDialogHeaderSubtitle]"></ng-content>
        </div>
    </div>

    <ng-content select="[saiDialogHeaderActions]"></ng-content>

    @if (showClose && closeWithDialog) {
        <button
            type="button"
            mat-icon-button
            class="header-close-btn"
            [mat-dialog-close]="closeResult"
            [matTooltip]="resolvedCloseTooltip"
            [attr.aria-label]="resolvedCloseAriaLabel"
            (click)="onCloseClick()"
        >
            <mat-icon>close</mat-icon>
        </button>
    } @else if (showClose) {
        <button
            type="button"
            mat-icon-button
            class="header-close-btn"
            [matTooltip]="resolvedCloseTooltip"
            [attr.aria-label]="resolvedCloseAriaLabel"
            (click)="onCloseClick()"
        >
            <mat-icon>close</mat-icon>
        </button>
    }
</div>
